/* eslint-disable no-nested-ternary */
import React, { } from 'react';
import moment from 'moment';
import * as echarts from 'echarts';
import classNames from 'classnames';
import { IMetricsTrendChartProps } from '@/pages/dashboard/components/MetricsTrendChart/types';
import MetricsTrendChart from '@/pages/dashboard/components/MetricsTrendChart';
import { contrastLine, getCardChart, xAxisHighLight } from '@/pages/dashboard/components/Chart/_config/plug';

import './index.scss';

const MetricsCardTrendChart: React.FC<IMetricsTrendChartProps> = (props) => {
  const {
    className,
    style,
    metricData,
    loading,
    error,
    filterVal,
    componentMetrics,
    height = 75,
    setOtherConfigFunc,
    showConfig = {
      showLineChart: true,
      showBubbleTitle: true,
    },
    isMoblie = false,
    isNightingale = false,
    isPlatform = false,
    isLeftCard = true,
    isRightCard = false,
    isOnlyChart = true,
    yAxisName,
    isEmptyData,
    xAxisBoundaryGap = true,
    ...restProps
  } = props;

  const { timeType = 'Day' } = filterVal || {};
  const configFunc = (option: any) => {
    let opt = getCardChart(option, { timeType });
    opt.series = opt?.series?.map((item: any, i: number) => {
      const lineColor = item.itemStyle?.color || (i === 0 ? '#5086F3' : '#69D19C');
      const areaStyle = {
        opacity: 0.25,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: lineColor
          },
          {
            offset: 1,
            color: '#FFF'
          },
        ])
      };

      const emphasis = { focus: 'series' as const };
      // 柱形图不应叠加 areaStyle（折线图专用渐变）
      // 堆叠柱多个 series 同属一根柱子：focus: 'series' 会 blur 其它段导致颜色变淡
      if (item.type === 'bar') {
        return {
          ...item,
          emphasis: {
            focus: 'none' as const,
            itemStyle: { ...item.itemStyle, opacity: 1 },
          },
          blur: { itemStyle: { ...item.itemStyle, opacity: 1 } },
        };
      }
      return {
        ...item,
        areaStyle,
        emphasis,
      };
    });
    if (isNightingale) {
      opt = contrastLine(opt, {
        formatter: (value: any) => {
          const val = value?.slice(11, 13)?.replace(/\b(0+)/gi, "");
          return value ? val === '' ? 0 : val : '';
        },
        xSplitNumber: 6
      });
    }
    opt = xAxisHighLight(opt, {
      lineStyle: {
        type: 'solid'
      },
      formatter: (params: any) => {
        const time = moment(params?.value).format('HH:mm');
        return isNightingale ? time : timeType === 'Month' ? params?.value?.slice(4, 6) : params?.value?.slice(-2);
      },
      symbolSize: 8,
      fontSize: 11,
    });
    if (opt?.xAxis?.[0]) {
      opt.xAxis[0].boundaryGap = xAxisBoundaryGap;
    }
    opt.grid = {
      x: isMoblie ? 10 : 6,
      y: 12,
      x2: isNightingale ? 6 : 2,
      y2: 0,
      containLabel: true
    };
    // 设计稿大小是11
    opt.legend.show = false;
    opt.xAxis[0].axisLabel.fontSize = 11;
    opt.xAxis[0].axisLabel.color = '#BBBDCB';
    opt.yAxis.axisLabel.fontSize = 11;
    opt.yAxis.axisLabel.color = '#BBBDCB';
    opt.tooltip.confine = false; // 浮窗不限制在图表区域
    opt.tooltip.axisPointer.label.padding = [5, 1, 0, 1];
    if (isPlatform) {
      opt.tooltip.position = function (point: number[], params: any, dom: any, rect: any, size: { viewSize: number[]; }) {
        const obj: any = { top: 60 };
        obj[['left', 'right'][+(point[0] < size.viewSize[0] / 2)]] = 5;
        return obj;
      };
    }
    // 最左侧卡片
    if (isLeftCard) {
      opt.tooltip.position = function (point: number[], params: any, dom: any, rect: any, size: { viewSize: number[]; }) {
        const obj: any = {
          top: point[1] - 120
        };
        const map: any = {
          right: point[10] + point[10] - size.viewSize[0] - 20,
          left: -20,
        };
        const pos = isNightingale ? 'left' : ['right', 'left'][+(point[0] < size.viewSize[0] / 2)];
        obj[pos] = isNightingale ? point[0] : point[0] - map[pos];
        return obj;
      };
    }
    // 最右侧卡片
    if (isRightCard) {
      opt.tooltip.position = 'left';
    };
    return opt;
  };

  return (
    <div className={classNames('dbd-metrics-card__flex', className)} style={style}>
      <div style={{ position: 'relative', width: '100%' }}>
        {(metricData && !isEmptyData) && <div className="dbd-metrics-trend-y-axis-name">
          {yAxisName}
        </div>}
        <MetricsTrendChart
          metricData={metricData}
          componentMetrics={componentMetrics}
          loading={loading}
          error={error}
          filterVal={filterVal}
          showConfig={showConfig}
          setOtherConfigFunc={configFunc}
          height={height}
          isOnlyChart={isOnlyChart}
          {...restProps}
        />
      </div>
    </div>
  );
};

export default MetricsCardTrendChart;